import { setUserData } from 'appRedux/actions';
import { store } from 'appRedux/store';

export const terminalUserLogout = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('userData');
  store.dispatch(setUserData(null));
  if (typeof window.external.showTapPage === 'function') {
    window.external.showTapPage(true);
    return;
  }
  window.history.pushState({}, '', '/');
};
